import { SelectOptionType } from 'types';
import { settlementTexts } from 'consts/text';
import { SortVariant } from './ChildrenSettlementPage.types';

export const sorterOptions: SelectOptionType<SortVariant, string>[] = [
    { label: settlementTexts.children.sort.nameAsc, value: SortVariant.NAME_ASC },
    { label: settlementTexts.children.sort.nameDsc, value: SortVariant.NAME_DESC },
    { label: settlementTexts.children.sort.groupAsc, value: SortVariant.GROUP_ASC },
    { label: settlementTexts.children.sort.groupDsc, value: SortVariant.GROUP_DESC },
    {
        label: settlementTexts.children.sort.settlementEndAsc,
        value: SortVariant.SETTLEMENT_END_ASC,
    },
    {
        label: settlementTexts.children.sort.settlementEndDsc,
        value: SortVariant.SETTLEMENT_END_DESC,
    },
];
